import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../components/common/BackButton";
import CustomiseSection from "../components/collection/CustomiseSection";

// 1. The Individual Product Card Component
const EmbroideryCard = ({ product, onViewClick }) => {
    const [loupePos, setLoupePos] = useState({ x: 0, y: 0 });
    const [imagePos, setImagePos] = useState({ x: 0, y: 0 });
    const imageWrapperRef = useRef(null);

    // This function calculates the mouse position relative to the image container
    // and updates the position of the loupe circle and the image inside it.
    const handleMouseMove = (e) => {
        const { left, top, width, height } =
            imageWrapperRef.current.getBoundingClientRect();

        // Mouse coordinates relative to the wrapper
        const x = e.clientX - left;
        const y = e.clientY - top;

        // Update Loupe Position (centered on mouse)
        setLoupePos({ x, y });

        // Update magnified image position *inside* the loupe.
        // New Formula:
        // We want the point (x, y) on the small image to correspond to the center of the loupe.
        // The large image is at -x * scale, -y * scale relative to the origin.
        // We add loupeRadius to center that 'view' in the loupe div.

        const scale = 2.8; // Matches CSS width: 250%
        const loupeRadius = 90; // Matches CSS width/height: 180px / 2 = 90

        setImagePos({
            x: -(x * scale) + loupeRadius,
            y: -(y * scale) + loupeRadius,
        });
    };

    return (
        <div className="pe-card-wrapper">
            <div className="pe-card pe-static-card">
                {/* --- Image Wrapper with Mouse Tracking --- */}
                <div
                    className="pe-image-wrapper"
                    ref={imageWrapperRef}
                    onMouseMove={handleMouseMove}
                // On mouse leave, maybe reset? Optional, but feels smoother if left as is.
                >
                    {/* The "Base" Photo (Flat) */}
                    <img
                        src={product.imageBase}
                        alt={product.title}
                        className="pe-base-image"
                    />

                    {/* The Magnifying Loupe Circle */}
                    <div
                        className="pe-loupe"
                        style={{ top: `${loupePos.y}px`, left: `${loupePos.x}px` }}
                    >
                        {/* The "Textured" Embroidery Image inside the loupe */}
                        <img
                            src={product.imageTexture}
                            alt="Embroidery Detail"
                            className="pe-loupe-image"
                            style={{
                                transform: `translate(${imagePos.x}px, ${imagePos.y}px)`,
                            }}
                        />
                    </div>
                </div>

                {/* --- Card Details --- */}
                <div className="pe-details">
                    {/* Replaced Category with ID */}
                    <span className="pe-category">PRODUCT ID: {product.id}</span>
                    <h3 className="pe-title">{product.title}</h3>

                    <div className="pe-button-container">
                        <button className="pe-btn" onClick={() => onViewClick(product)}>Click to View</button>
                    </div>
                </div>
            </div>
        </div>
    );
};




// 2. Main Container displaying the grid
export default function HoopEmbroideryCollection() {
    const navigate = useNavigate();

    // DUMMY DATA - Replace with your real data
    // IMPT: Use real, high-res embroidery closeups for 'imageTexture'
    const products = [
        {
            id: 'HE-01',
            category: "Wedding Memories",
            title: "The Day We Became Us",
            price: "₹ 2,499",
            imageBase: "images/hoop1.webp", // Flat photo
            imageTexture: "images/hoop1.webp", // Detailed texture (stand-in)
            description: "A romantic tribute to the start of your journey. This hoop captures the essence of your partnership with delicate stitches.",
            highlights: ["Hand-embroidered florals", "Custom date stitching", "Premium bamboo hoop"]
        },
        {
            id: 'HE-02',
            category: "Family Heirlooms",
            title: "Forever, Hand in Hand",
            price: "₹ 2,499",
            imageBase: "images/hoop2.webp",
            imageTexture: "images/hoop2.webp", // Texture stand-in
            description: "Celebrate the bond that holds you together. A perfect gift for anniversaries or to honor family ties.",
            highlights: ["Intricate knot work", "Durable cotton fabric", "Personalized names"]
        },
        {
            id: 'HE-03',
            category: "Wedding Memories",
            title: "A Promise Woven in Time",
            price: "₹ 2,499",
            imageBase: "images/carousel-1.webp", // Flat photo
            imageTexture: "images/carousel-1.webp", // Detailed texture (stand-in)
            description: "Your vows, immortalized in thread. A constant reminder of the promises you made to each other.",
            highlights: ["Silk thread detailing", "Elegant typography", "Available in various sizes"]
        },
        {
            id: 'HE-04',
            category: "Wedding Memories",
            title: "A Day Chosen by Fate",
            price: "₹ 2,499",
            imageBase: "images/hoop3.webp", // Flat photo
            imageTexture: "images/hoop3.webp", // Detailed texture (stand-in)
            description: "Remember the day that changed everything. This hoop art beautifuly frames your special date.",
            highlights: ["Floral border design", "High-contrast stitching", "Ready to hang"]
        },
    ];

    const handleViewProduct = (product) => {
        navigate('/product-view', { state: { product } });
    };

    return (
        <>
            <section className="pe-section">
                <div style={{ padding: "0 5%", maxWidth: "1200px", margin: "0 auto", marginTop: "20px" }}>
                    <BackButton />
                </div>
                <div className="pe-header">
                    <h2 className="pe-main-title">❖ Hoop Embroidery Collection ❖</h2>
                    <div className="pe-thread-line"></div>
                    <p className="pe-subtitle">
                        Transform fine threads into timeless hoop art.
                        A handcrafted expression of stories, emotions, and lasting beauty.
                    </p>
                </div>

                <div className="pe-grid">
                    {products.map((product) => (
                        <EmbroideryCard key={product.id} product={product} onViewClick={handleViewProduct} />
                    ))}

                </div>
            </section>
            <CustomiseSection />
        </>
    );
}